import styled from "styled-components";
import { Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";


export const CustomNavLink = styled(NavLink)`
    display: inline-block;
    ${({ $label, $color }) => $label?(
        `
            cursor: default;
            color: rgba(0, 0, 0, .6) !important;
            padding: .3em 1em;
            border-radius: 5px;
            ${$color && $color === "success"?`background-color: var(--success-color);`:``}
            ${$color && $color === "danger"?`background-color: var(--danger-color);`:``}
            ${$color && $color === "warning"?`background-color: var(--warning-color);`:``}
            &:hover{
                color: rgba(0, 0, 0, .6) !important;
                text-decoration: none;
            }
        `
    ):(
        `
            ${$color && $color === "success"?`color: var(--success-color);`:``}
            ${$color && $color === "danger"?`color: var(--danger-color);`:``}
            ${$color && $color === "warning"?`color: var(--warning-color);`:``}
            &:hover{
                color: inherit;
                text-decoration: none;
            }
        `
    )}
    
    
`
export const ButtonContainer = styled(Button)`
    &.btn{
        --bs-btn-padding-y: 0.6rem;
        --bs-btn-font-size: 1.1em;
        --bs-btn-font-weight: bold;
    }
    &.full{
        width: 100%;
    }
    &.btn-success {
        --bs-btn-color: #fff;
        --bs-btn-bg: rgb(34 197 94 / var(--tw-text-opacity, 1));
        --bs-btn-border-color: rgb(34 197 94 / var(--tw-text-opacity, 1));
        --bs-btn-hover-color: #fff;
        --bs-btn-hover-bg: #157347;
        --bs-btn-hover-border-color: #146c43;
        --bs-btn-focus-shadow-rgb: 60, 153, 110;
        --bs-btn-active-color: #fff;
        --bs-btn-active-bg: #146c43;
        --bs-btn-active-border-color: #13653f;
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #fff;
        --bs-btn-disabled-bg: #198754;
        --bs-btn-disabled-border-color: #198754;
    }
    &.btn-primary {
        --bs-btn-color: #fff;
        --bs-btn-bg: var(--primary-color);
        --bs-btn-border-color: var(--primary-color);
        --bs-btn-hover-color: #fff;
        --bs-btn-hover-bg: var(--primary-dark-color);
        --bs-btn-hover-border-color: var(--primary-dark-color);
        --bs-btn-focus-shadow-rgb: 49,132,253;
        --bs-btn-active-color: #fff;
        --bs-btn-active-bg: var(--primary-dark-color);
        --bs-btn-active-border-color: var(--primary-dark-color);
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #fff;
        --bs-btn-disabled-bg: #315891;
        --bs-btn-disabled-border-color: #315891;
    }
    &.btn-outline-primary {
        --bs-btn-color: var(--primary-color);
        --bs-btn-border-color: var(--primary-color);
        --bs-btn-hover-color: #fff;
        --bs-btn-hover-bg: var(--primary-dark-color);
        --bs-btn-hover-border-color: var(--primary-dark-color);
        --bs-btn-focus-shadow-rgb: 13, 110, 253;
        --bs-btn-active-color: #fff;
        --bs-btn-active-bg: var(--primary-dark-color);
        --bs-btn-active-border-color: var(--primary-dark-color);
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #315891;
        --bs-btn-disabled-bg: transparent;
        --bs-btn-disabled-border-color: #315891;
        --bs-gradient: none;
    }
    &.btn-light {
        --bs-btn-color: #000;
        --bs-btn-bg: #f8f9fa;
        --bs-btn-border-color: #f8f9fa;
        --bs-btn-hover-color: var(--primary-color);
        --bs-btn-hover-bg: #fff;
        --bs-btn-hover-border-color: #fff;
        --bs-btn-focus-shadow-rgb: 211, 212, 213;
        --bs-btn-active-color: var(--primary-color);
        --bs-btn-active-bg: #fff;
        --bs-btn-active-border-color: #fff;
        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        --bs-btn-disabled-color: #000;
        --bs-btn-disabled-bg: #f8f9fa;
        --bs-btn-disabled-border-color: #f8f9fa;
    }
`